import React from 'react'
import List from './List'
import {hubblerStudioData} from '../data/webData'
import hubblerStudio from '../images/hubbler-studio-1.png'


class ListItem extends React.Component{
    onClickHandler(event){
        let curElement = event.target
        while(!curElement.classList.contains('list-item')){
            curElement = curElement.parentNode;
        }
        const {itemData} = this.props
        this.props.onClickHandler(itemData.id,curElement)
    }
    render(){
        const {itemData,activeItem} = this.props
        return  <li id={itemData.id} className={activeItem === itemData.id ? `active list-item ${itemData.activeLabel || ''}` : `list-item ${itemData.activeLabel || ''}`} onClick={this.onClickHandler.bind(this)}>
            <div className={'line'}></div>
            <div className={'head'}>{itemData.title}</div>
            {itemData.description? <div className={'discription'}>{itemData.description}</div> : ''}
        </li>
    }
}

export default class HubblerStudio extends React.Component{
    constructor(){
        super()
        this.state = {
            activeItem:'1',
            offsetTop:0
        }
    }
    onClickHandler(id,curElement){
        this.setState({
            activeItem:id,
            offsetTop:curElement.offsetTop
        })
    }
    render(){
        const styleChange = (this.state.activeItem === '1' || this.state.activeItem === '5') ? true : false
        return <div className={'hubbler-studio'}>
            <div className={'title'} data-aos="fade-up">Powered by <span>Hubbler Studio</span></div>
            <div className={'details'} data-aos="fade-up">
                <p>Convert any business process into an automated workflow with absolutely no coding!
                    You can make Hubbler work for your enterprise the way you want it to.</p>
                <div className={'sub'}>
                  {/*  <div className={'text'}>
                        Custom apps with no Code
                    </div>
                    <p>Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia</p>*/}
                </div>
            </div>
{/*
            <button className={'bt-blue'} data-aos="fade-up">Try now for free</button>
*/}
            <div className={'studio-list-container'}>
                <div className={'studio-list'} data-aos="fade-up" data-aos-delay="150">
                    <List items={hubblerStudioData} listItem={ListItem} activeItem={this.state.activeItem} onClickHandler={this.onClickHandler.bind(this)}/>
                    <div className={styleChange ? 'animate-active small' : 'animate-active'} style={{top:this.state.offsetTop}}></div>
                </div>
                <div className={'studio-preview'}>
                    <img src={hubblerStudio} alt="hubblerStudio" data-aos="zoom-out-right"/>
                </div>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/HubblerStudio.js